'use strict';
angular
    .module('resCtrModalModule', [
        'takeDraftModule',
        'reserveModalModule',
        'resourceExportModule',
        'resourceInfoModule',
        'weichatModule',
        'createGroupModule',
        'showGroupModule',
        'printModalModule',
        'digitalModule',
        'showPGroupModule',
        'resourceMultiImgsUploaderModule',
        'resourceEditImageModule',
        'resTakeDraftDownloadImgsModule',
        'tenantShareManuRecordModule',
        'prirejectionWithAppendixModule',
    ])
    .factory('resCtrModalService', function($modal, $q) {
        return {

            /**
             * [reserveDraft description] 预留稿件
             * @param  {[type]}  items [description] 需要预留的稿件类表
             * @param  {Boolean} isUgc [description] 是否是UGC类型稿件
             * @return {[type]}        [description]
             */
            reserveDraft: function(items, isUgc) {
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/reserveModal/reserveModal.html',
                    windowClass: 'resource-reserve-modal',
                    backdrop: false,
                    controller: 'reserveModalCtrl',
                    resolve: {
                        items: function() {
                            return items;
                        },
                        isUgc: function() {
                            return isUgc;
                        },
                    },
                });
                return modalInstance;
            },
            exportModal: function() {
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/exportModal/exportModal.html',
                    size: 'sm',
                    windowClass: 'exportModal',
                    backdrop: false,
                    controller: 'exportModalCtrl',
                });
                return modalInstance;
            },
            infoModal: function(docId, isShowRepeat, showClick, operFlags, isUGC, isTenant, isPropaganda, isCrossTenant) {
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/infoModal/infoModal.html',
                    size: 'lg',
                    windowClass: 'bigDataInfoModal',
                    backdrop: false,
                    controller: 'infoModalCtrl',
                    resolve: {
                        params: function() {
                            return {
                                isShowRepeat: isShowRepeat,
                                docId: docId,
                                showClick: showClick,
                                operFlags: operFlags,
                                isUGC: isUGC,
                                isTenant: isTenant,
                                isPropaganda: isPropaganda,
                                isCrossTenant: isCrossTenant
                            };
                        },
                    },
                });
                return modalInstance;
            },
            operRecordsModal: function(flagData, operFlags, selected) {
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/operRecordsModal/operRecordsModal_tpl.html',
                    size: 'lg',
                    windowClass: 'bigDataInfoModal',
                    backdrop: false,
                    controller: 'operRecordsModalCtrl',
                    resolve: {
                        params: function() {
                            return {
                                data: flagData,
                                operFlags: operFlags,
                                selected: selected,
                            };
                        },
                    },
                });
                return modalInstance;
            },
            bigDataInfoModal: function(guid, isShowRepeat, showClick, operFlags) {
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/infoModal/infoModal.html',
                    size: 'lg',
                    windowClass: 'bigDataInfoModal',
                    backdrop: false,
                    controller: 'bigDataInfoModalCtrl',
                    resolve: {
                        options: function() {
                            return {
                                guid: guid,
                                isShowRepeat: isShowRepeat,
                                showClick: showClick,
                                operFlags: operFlags,
                            };
                        },
                    },
                });
                return modalInstance;
            },

            /* xhsgInfoModal: function(docId, isShowRepeat) {
            var modalInstance = $modal.open({
                templateUrl: "./resourceCenter/service/modal/infoModal/infoModal.html",
                size: 'lg',
                windowClass: 'infoModal',
                backdrop: false,
                controller: "xhsgInfoModalCtrl",
                resolve: {
                    params: function() {
                        return {
                            'isShowRepeat': isShowRepeat,
                            'docId': docId
                        };
                    }
                }
            });
            return modalInstance;
        },*/
            weiChatModal: function(item) {
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/weichatModal/weiChatModal.html',
                    size: 'lg',
                    windowClass: 'infoModal',
                    backdrop: false,
                    controller: 'weichatCtrl',
                    resolve: {
                        selectedSource: function() {
                            return item;
                        },
                    },
                });
                return modalInstance;
            },
            createGroup: function(temp) {
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/createModal/createmodal.html',
                    windowClass: 'subscribe_modal mt120',
                    backdrop: temp || false,
                    controller: 'createGroupCtrl',
                    resolve: {
                        hasCloseAlert: function() {
                            return temp;
                        },
                    },
                });
                return modalInstance;
            },
            showGroup: function(editValues) {
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/groupModal/groupmodal.html',
                    windowClass: 'resource-take-draft',
                    backdrop: false,
                    controller: 'showGroupCtrl',
                    resolve: {
                        editValues: function() {
                            return editValues;
                        },
                    },
                });
                return modalInstance;
            },

            /**
             * [fullTakeDraft description] 取稿弹窗
             * @param  {object}  params    [description] 取稿方法参数
             * @param  {Boolean} isOnlyOne [description] 是否只有一篇稿件
             * @param  {array}   items     [description] 被取稿的稿件李诶包
             * @param  {Boolean} isUgc     [description] 是否是UGC稿件，如果是UGC稿件，客户端不需要校验栏目
             * @param  {Boolean} directEdit     [description]
             * @return {[type]}            [description]
             */
            fullTakeDraft: function(params, isOnlyOne, items, isUgc, directEdit) {
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/takeDraftModal/takeDraft_tpl.html',
                    windowClass: 'resource-take-draft',
                    backdrop: false,
                    resolve: {
                        basicParams: function() {
                            return params;
                        },
                        isOnlyOne: function() {
                            return isOnlyOne;
                        },
                        items: function() {
                            return items;
                        },
                        isUgc: function() {
                            return isUgc;
                        },
                        directEdit: function() {
                            return directEdit;
                        },
                    },
                    controller: 'fullTakeDraftCtrl',
                });
                return modalInstance;
            },
            printModal: function(params) {
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/printModal/printModal.html',
                    windowClass: 'resource_printModal',
                    backdrop: false,
                    resolve: {
                        params: function() {
                            return params;
                        },
                    },
                    controller: 'printModalCtrl',
                });
                return modalInstance;
            },

            /**
             * [rejectionWithAppendix description]带有上传附件的退稿
             *
             * @param   {[type]}  option  [option description]
             *
             * @return  {[type]}          [return description]
             */
            rejectionWithAppendix: function (option) {
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/rejectionWithAppendix/rejectionWithAppendix.html',
                    windowClass: 'rejectionWithAppendix inputModel',
                    backdrop: false,
                    resolve: {
                        option: function() {
                            return option;
                        },
                    },
                    controller: 'prirejectionWithAppendixCtrl',
                });
                return modalInstance;
            },

            /**
             * [digitalModal description] 数字报 选择报刊
             * @param  {object}  item    [description]
             * @return  {[type]}  [return description]
             */
            digitalModal: function(item) {
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/weichatModal/weiChatModal.html',
                    size: 'lg',
                    windowClass: 'infoModal',
                    backdrop: false,
                    controller: 'digitalCtrl',
                    resolve: {
                        selectedSource: function() {
                            return item;
                        },
                    },
                });
                return modalInstance;
            },
            subscribeModal: function(items) {
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/groupModal/parentgroupmodal.html',
                    windowClass: 'resource-take-draft',
                    backdrop: false,
                    controller: 'showPGroupCtrl',
                    resolve: {
                        selectedSource: function() {
                            return items;
                        },
                    },
                });
                return modalInstance;
            },

            /**
             * [imageUpload description]图集稿图片批量上传
             * @param  {[fun]} specialCase [description]
             * @param  {[fun]} success [description]上传成功后的回调
             * @return {[type]}         [description]
             */
            imageUpload: function(specialCase, success) {
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/uploadImgModal/resourceMultiImage_tpl.html',
                    windowClass: 'resource-multiImgsUploader',
                    backdrop: false,
                    resolve: {
                        specialCase: function() {
                            return specialCase;
                        },
                    },
                    controller: 'resourceMultiImgsUploaderCtrl',
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            /**
             * [editUploaderImg description]编辑图片
             * @param  {[fun]} uploadImg [description]
             * @param  {[fun]} specialCase [description]上传成功后的回调
             * @param  {[fun]} success [description]
             * @return {[type]} [description]
             */
            resourceUploaderImg: function(uploadImg, specialCase, success) {
                var multiImgsUploader = $modal.open({
                    templateUrl: './resourceCenter/service/modal/uploadImgModal/resourceEditImage_tpl.html',
                    resolve: {
                        uploadImg: function() {
                            return uploadImg;
                        },
                        specialCase: function() {
                            return specialCase;
                        },
                    },
                    windowClass: 'resource-multiImgsUploader',
                    backdrop: false,
                    controller: 'resourceEditImageCtrl',
                });
                multiImgsUploader.result.then(function(result) {
                    success(result);
                });
            },

            /**
             * [takeDraftDownloadImgs description] 取稿中下载图片的弹窗
             * @param  {[type]} data    [description]   取稿结果数据
             * @param  {[type]} success [description]
             * @return {[type]}         [description]
             */
            takeDraftDownloadImgs: function(data, success) {
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/takeDraftDownloadImgs/takeDraftDownloadImgs_tpl.html',
                    windowClass: 'resource-takedraft-downloadimgs',
                    backdrop: false,
                    resolve: {
                        basicParams: function() {
                            return data;
                        },
                    },
                    controller: 'resTakeDraftDownloadImgsCtrl',
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            /**
             * [tenantShareManu description] 稿件间共享
             * @param  {[type]} item [description]
             * @return {[type]} [description]
             */
            tenantShareManuRecord: function(item) {
                var deffer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/tenantShareManuRecord/main_tpl.html',
                    windowClass: 'tenant-share-manu-record-window',
                    backdrop: false,
                    controller: 'tenantShareManuRecordCtrl',
                    resolve: {
                        item: function() {
                            return item;
                        },
                    },
                });
                modalInstance.result.then(
                    function(data) {
                        deffer.resolve(data);
                    },
                    function() {}
                );
                return deffer.promise;
            },

            /**
             * [options 评论弹窗]
             *
             * @param   {[type]}  options  [options description]
             * @param   {[type]}  htmlTpl  [options description]
             * @return  {[type]}           [return description]
             */
            commentModal: function (options, htmlTpl) {
                var url = './resourceCenter/service/modal/comment/comment_tpl.html';
                // if (type === 'editor') {
                //     url = './resourceCenter/service/modal/comment/comment.html';
                // } else if (type === 'sddetail') {
                //     url = './resourceCenter/service/modal/comment/commentsddetail.html';
                // } else if (type === 'zddetail') {
                //     url = './resourceCenter/service/modal/comment/commentzddetail.html';
                // }
                
                // html不同，只需要传相应的模板url即可
                if (htmlTpl) {
                    url = './resourceCenter/service/modal/comment/' + htmlTpl + '.html';
                }
                var deffer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: url,
                    windowClass: 'comment-window',
                    backdrop: false,
                    controller: 'commentCtrl',
                    resolve: {
                        options: function(){
                            return options;
                        }
                    }
                });
                modalInstance.result.then(function (result) {
                    deffer.resolve(result);
                });
                return deffer.promise;
            },
        };
    });
